

// This file is only necessary if the A/B test Test 2: Visual Nav on PLPs is implemented in Inteligems, otherwise you have to remove the display: none; that has the component of the .slider-mobile-gutter class in the link-bar.liquid section.

document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector(".slider-mobile-gutter");
    const currentPath = window.location.pathname;

    const showPaths = ["/", "/pages/mens", "/pages/womens"];

    if (showPaths.includes(currentPath)) {
        if (slider) {
            slider.style.display = "block";
        }
    }
});
